"use client";

import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { parseMessage } from "@/lib/utils";
import { NJ_WS_URL } from "@/lib/constants";

// const HEARTBEAT_VALUE = 1;

function WebChat() {
  const [ws, setWs] = useState<WebSocket | null>(null);
  const [messages, setMessages] = useState<string[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);

  // useEffect(() => {
  //   if (ws) {
  //     const pingInterval = setInterval(() => {
  //       if (ws.readyState === WebSocket.OPEN) {
  //         const data = new Uint8Array(1);
  //         data[0] = HEARTBEAT_VALUE;
  //         ws.send(data);
  //       }
  //     }, 5000); // Adjust the interval as needed

  //     return () => clearInterval(pingInterval);
  //   }
  // }, [ws]);


  function handleOpenWS() {
    handleCloseConnection();
    const newWs = new WebSocket(NJ_WS_URL);

    newWs.onopen = () => {
      setWs(newWs);
      const successMessage = "WebSocket connection opened";
      setMessages((prevMessages) => [...prevMessages, successMessage]);
    };

    newWs.onclose = () => {
      setWs(newWs);
      const successMessage = "WebSocket connection closed";
      setMessages((prevMessages) => [...prevMessages, successMessage]);
    };

    newWs.onerror = (error) => {
      console.log(error);
      const errorMessage = `WebSocket connection failed`;
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
    };

    newWs.onmessage = (event) => {
      const formattedMessage = parseMessage(event.data);
      if (formattedMessage) {
        setMessages((prevMessages) => [...prevMessages, formattedMessage]);
      }
    };

    setWs(newWs);
  }

  function handleCloseConnection() {
    if (ws) {
      ws.close();
      setWs(null);
    }
  }

  function handleSend() {
    if (ws && ws.readyState === WebSocket.OPEN && inputRef.current) {
      const message = inputRef.current.value;
      ws.send(message);
      inputRef.current.value = "";
    } else {
      const errorMessage = "WebSocket is not open";
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  }

  return (
    <div className="flex flex-col gap-6 justify-center w-full items-center">
      <h1 className="text-xl">Test Websocket:</h1>
      <div className="flex gap-2">
        <Button
          id="ws-open"
          onClick={handleOpenWS}
          variant="secondary"
          disabled={(ws && ws.readyState === WebSocket.OPEN) || false}
        >
          Open Connection
        </Button>
        <Button
          id="ws-close"
          onClick={handleCloseConnection}
          variant="destructive"
          disabled={!(ws && ws.readyState === WebSocket.OPEN) || false}
        >
          Close Connection
        </Button>
      </div>

      <div className="flex gap-2">
        <input
          type="text"
          id="ws-input"
          className="h-10 w-72 p-2 border-2 border-solid border-blue-400"
          ref={inputRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSend();
            }
          }}
        />
        <Button id="ws-send" onClick={handleSend}>
          Send message
        </Button>
      </div>
      <pre id="messages">
        {messages.map((msg, index) => (
          <div key={index}>{msg}</div>
        ))}
      </pre>
    </div>
  );
}

export default WebChat;
